"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.calloutMaxHeight = exports.gridSubUnit = exports.gridUnit = void 0;

/**
 * The grid unit size in pixels
 * */
var gridUnit = 8;
exports.gridUnit = gridUnit;
var gridSubUnit = 4;
exports.gridSubUnit = gridSubUnit;
var calloutMaxHeight = 8 * 4 * 12;
/* 32 is item size, show 12 items */

exports.calloutMaxHeight = calloutMaxHeight;